import { useContext, useEffect } from "react";

import MyProposalsContext from "../context/MyProposalsContext";
import { useAppState } from "../context/AppStateContext";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";

import ResponsiveAppBar from "../components/layout/ResponsiveAppBar";
import ListHeader from "../components/proposal/myProposal/ListHeader";
import Searchbar from "../components/layout/Searchbar";
import CustomTable from "../components/layout/CustomTable";
import Loader from "../components/layout/Loader";
import ErrorModal from "../components/layout/ErrorModal";
import CustomPagination from "../components/layout/CustomPagination";
import NoData from "../components/layout/NoData";

const MyProposalsPage = () => {
  const { apiRes, setApiRes } = useAppState();
  const {
    getMyProposals, tableHeading, proposalList, pageData,
    handlePaginationClick, navigateToEdit, searchQuery, setSearchQuery,
  } = useContext(MyProposalsContext);

  useEffect(() => {
    getMyProposals();
  }, []);

  return (
    <Box className="mainContainer">
      {apiRes.loading && <Loader />}

      <ResponsiveAppBar />
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          <ListHeader />
          <Searchbar
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />
          <CustomTable
            heading={tableHeading}
            rows={proposalList}
            pageData={pageData}
            navigateToEdit={navigateToEdit}
            idKey='uid'
          />

          {proposalList.length === 0 && <NoData />}

          {
            (proposalList.length !== 0 && pageData.current.pageCount !== 1) &&
            <CustomPagination
              pageData={pageData}
              handlePaginationClick={handlePaginationClick}
            />
          }
        </Grid>
      </Container>
      <ErrorModal apiRes={apiRes} setApiRes={setApiRes} />
    </Box>
  );
};

export default MyProposalsPage;